export default "__VITE_ASSET__B1m7iWy0__"